import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AuthState {
  email: string | null;
  name: string | null;
  role: string | null;
  token: string | null;
}

export const isAuth = false;

const initialState: AuthState = {
  email: null,
  name: null,
  role: null,
  token: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (
      state,
      action: PayloadAction<{
        email: string;
        name: string;
        role: string;
        token: string;
      }>
    ) => {
      state.email = action.payload.email;
      state.name = action.payload.name;
      state.role = action.payload.role;
      state.token = action.payload.token;
    },
    defaultState: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser, defaultState } = authSlice.actions;

export default authSlice.reducer;
